import React, { useEffect } from "react";
import "./success.css";
import { SmsViewbooking } from "../../Redux/Actions";
import TopNav from "../TopNav/TopNav";
// import Header from "../Header/Header";
import NewHeader from "../NewHeader/NewHeader";
import Footer from "../Footer/Footer";
import { useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
function Success() {
  const Data = useSelector((state) => state.smsView);
  const { smsViewData } = Data;

  console.log(smsViewData);
  const { idSlug } = useParams();

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(SmsViewbooking(idSlug));
  }, [idSlug]);

  return (
    <>
      {/* <TopNav /> */}
      <NewHeader />
      <div className="bookingSummary">
        <h1>Booking Summary</h1>
        <div className="bookingDiv">
          {/**HEADER details */}
          <div className="bookingHeader">
            <div className="bookingText">
              <span>Booking ID</span>
              <span>{smsViewData?.pk}</span>
            </div>
            <div className="bookingText">
              <span>Patient</span>
              <span>{smsViewData?.additional_members?.length + 1}</span>
            </div>
            <div className="bookingText">
              <span>Grand Total</span>
              <span>₹ {smsViewData?.discounted_price?.final_total_price}</span>
            </div>
          </div>
          {/**Booking Main */}
          <div className="bookingMain">
            <h2>Patient Information</h2>

            <div className="bookingMainChild">
              <div className="userName">
                {smsViewData.customer_name}{" "}
                <span>
                  ( {smsViewData?.customer_gender} / {smsViewData?.customer_age}{" "}
                  Yrs.)
                </span>
              </div>
              <div className="booking_Detail_Summary">
                <h4>Address</h4>
                <p>{smsViewData?.customer_address}</p>
              </div>
              <div className="booking_Detail_Summary">
                <h4>TEST BOOKED</h4>
                {smsViewData?.packages?.map((item) => {
                  return (
                    <div>
                      <h4>{item?.name}</h4>
                      <span className="colorBlue">
                        Reporting Time :{" "}
                        {item?.tat_time ? `${item?.tat_time}` : "Not Available"}{" "}
                      </span>
                      {/* <p>
                    Lipid Profile, Liver Function Test, Complete Hemogram,
                    Thyroid Profile-Total (T3, T4 & TSH Ultra-sensitive), Iron
                    Studies, Kidney Function Test, HbA1c, Urine Routine &
                    Microscopy Extended, Blood Glucose Fasting, Vitamin B12
                    Cyanocobalamin, Vitamin D Total-25 Hydroxy,{" "}
                  </p> */}
                    </div>
                  );
                })}
                {/* <div className="twoDiv">
                  <div>
                    <h4>Cancer Screening Package For Female (3 parameters)</h4>
                    <span className="colorBlue">Reporting Time : 192 hrs</span>
                    <p>
                      CA-125, Serum, CA-15.3, Serum, CEA Carcino Embryonic
                      Antigen Serum,
                    </p>
                  </div>
                  <div>
                    <h4>Basic Cardiac Addon Package (2 parameters)</h4>
                    <span className="colorBlue">Reporting Time : 24 hrs</span>
                    <p>Homocysteine, HsCRP High Sensitivity CRP,</p>
                  </div>
                </div> */}
                {/* <div className="tat_data">
                  <span>Fasting required - 10hrs</span>
                </div> */}
              </div>
            </div>

            <div className="paymentInfo">
              <h2>Booking & Payment Information</h2>

              <div className="paymentDetails">
                <div className="paymentTop">
                  <div className="child">
                    <span>Sample Collection Date</span>
                    <span>{smsViewData?.collection_date}</span>
                  </div>
                  <div className="child">
                    <span>Sample Collection time</span>
                    <span>{smsViewData?.slot_time?.slot}</span>
                  </div>
                </div>
                <div className="orderDetails">
                  <h4>Order Details</h4>
                  <div className="detailsTable">
                    {/* <div className="detailsRow">
                      <span>Payment Date </span> <span>{}</span>
                    </div> */}
                    {/* <div className="detailsRow">
                      <span>Payment Gateway </span> <span>razor</span>
                    </div> */}
                    {/* <div className="detailsRow">
                      <span>Payment Amount </span> <span>₹ 1517</span>
                    </div> */}
                    {/* <div className="detailsRow">
                      <span>Transaction ID </span>{" "}
                      <span>T2107130720333562479710</span>
                    </div> */}
                    <div className="orderAmount">
                      <div className="child">
                        <span>Order Amount</span>
                        <span>
                          ₹ {smsViewData?.discounted_price?.final_total_price}
                        </span>
                      </div>
                      {/* <div className="child">
                        <span>HCash Amount</span>
                        <span>- ₹ 80</span>
                      </div> */}
                    </div>

                    <div className="totalPaid child">
                      <span>Total paid amount</span>
                      <span>₹ {smsViewData?.amount?.paid_amount}</span>
                    </div>
                  </div>
                  <div className="totalFinalAmount child">
                    <h4>Total Payable</h4>
                    <span>₹ {smsViewData?.amount?.receivable_amount}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {smsViewData?.additional_members
            ? smsViewData?.additional_members.map((main) => {
                console.log(main, "here");
                return (
                  <div className="bookingMain">
                    <h2>Patient Information</h2>

                    <div className="bookingMainChild">
                      <div className="userName">
                        {main.customer_name}{" "}
                        <span>
                          ( {main?.customer_gender} / {main?.customer_age} Yrs.)
                        </span>
                      </div>
                      <div className="booking_Detail_Summary">
                        <h4>TEST BOOKED</h4>
                        {main?.packages?.map((item) => {
                          return (
                            <div>
                              <h4>{item?.name}</h4>
                              <span className="colorBlue">
                                Reporting Time :{" "}
                                {item?.tat_time
                                  ? `${item?.tat_time}`
                                  : "Not Available"}{" "}
                              </span>
                              {/* <p>
                    Lipid Profile, Liver Function Test, Complete Hemogram,
                    Thyroid Profile-Total (T3, T4 & TSH Ultra-sensitive), Iron
                    Studies, Kidney Function Test, HbA1c, Urine Routine &
                    Microscopy Extended, Blood Glucose Fasting, Vitamin B12
                    Cyanocobalamin, Vitamin D Total-25 Hydroxy,{" "}
                  </p> */}
                            </div>
                          );
                        })}
                        {/* <div className="twoDiv">
                  <div>
                    <h4>Cancer Screening Package For Female (3 parameters)</h4>
                    <span className="colorBlue">Reporting Time : 192 hrs</span>
                    <p>
                      CA-125, Serum, CA-15.3, Serum, CEA Carcino Embryonic
                      Antigen Serum,
                    </p>
                  </div>
                  <div>
                    <h4>Basic Cardiac Addon Package (2 parameters)</h4>
                    <span className="colorBlue">Reporting Time : 24 hrs</span>
                    <p>Homocysteine, HsCRP High Sensitivity CRP,</p>
                  </div>
                </div> */}
                        {/* <div className="tat_data">
                  <span>Fasting required - 10hrs</span>
                </div> */}
                      </div>
                    </div>

                    <div className="paymentInfo">
                      <h2>Booking Information</h2>

                      <div className="paymentDetails">
                        <div className="paymentTop">
                          <div className="child">
                            <span>Sample Collection Date</span>
                            <span>{main?.pickup_date}</span>
                          </div>
                          <div className="child">
                            <span>Sample Collection time</span>
                            <span>{main?.pickup_time}</span>
                          </div>
                        </div>
                        {/* <div className="orderDetails">
                  <h4>Order Details</h4>
                  <div className="detailsTable">
                    <div className="detailsRow">
                      <span>Payment Date </span> <span>{}</span>
                    </div>
                    <div className="detailsRow">
                      <span>Payment Gateway </span> <span>razor</span>
                    </div>
                    <div className="detailsRow">
                      <span>Payment Amount </span> <span>₹ 1517</span>
                    </div>
                    <div className="detailsRow">
                      <span>Transaction ID </span>{" "}
                      <span>T2107130720333562479710</span>
                    </div>
                    <div className="orderAmount">
                      <div className="child">
                        <span>Order Amount</span>
                        <span>₹ {main?.discounted_price?.final_total_price}</span>
                      </div>
                      <div className="child">
                        <span>HCash Amount</span>
                        <span>- ₹ 80</span>
                      </div>
                    </div>

                    <div className="totalPaid child">
                      <span>Total paid amount</span>
                      <span>₹ {main?.amount?.paid_amount}</span>
                    </div>
                  </div>
                  <div className="totalFinalAmount child">
                    <h4>Total Payable</h4>
                    <span>₹ {main?.amount?.receivable_amount}</span>
                  </div>
                </div> */}
                      </div>
                    </div>
                  </div>
                );
              })
            : null}

          <div className="">
            <h2>Sample Collector Information</h2>
            <div className="sampleCollect">
              <div className="child">
                {" "}
                <span> sample collector name :</span>
                {smsViewData?.phlebo?.name}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="success">
        <h1>Your Booking has been confirmed !</h1>
      </div> */}
      <Footer />
    </>
  );
}

export default {
  component: Success,
};
